import React from "react";
import cns from "classnames";
import { withStyles, createStyles } from "@material-ui/core";
import MuiButtonBase, { ButtonProps } from "@material-ui/core/Button";

import { Classes, ThemeType } from "@theme";
import { Spinner } from "../Spinner";

type IconSize = "small" | "medium";

const iconSizes: { [key in IconSize]: number } = {
  small: 12,
  medium: 20
};

export type BaseIconButtonProps = ButtonProps & {
  loading?: boolean;
  loadingContent?: React.ReactNode;
  leftIcon?: React.ReactElement<any>;
  rightIcon?: React.ReactElement<any>;
  iconSize?: IconSize;
  [other: string]: any;
};

type Props = BaseIconButtonProps & {
  classes: Classes<typeof styles>;
};

export class BaseIconButton extends React.Component<Props> {
  static defaultProps: Partial<Props> = {
    leftIcon: null,
    rightIcon: null,
    iconSize: "medium"
  };

  render() {
    const {
      classes,
      className,
      children,
      leftIcon,
      loading,
      loadingContent,
      onClick,
      rightIcon,
      iconSize: iconSizeProp,
      ...props
    } = this.props;

    const iconSize = iconSizes[iconSizeProp];
    const rootClassName = cns(classes.root, className, {
      [classes.iconButton]: !children
    });

    const content = loading && loadingContent ? loadingContent : children;

    return (
      <MuiButtonBase
        className={rootClassName}
        onClick={(e) => {
          onClick && onClick(e);
        }}
        {...props}
      >
        {leftIcon
          ? React.cloneElement(leftIcon, {
              className: classes.leftIcon,
              width: iconSize,
              height: iconSize
            })
          : null}

        <span>{content}</span>

        {loading && <Spinner color="inherit" size={12} />}

        {rightIcon
          ? React.cloneElement(rightIcon, {
              className: classes.rightIcon,
              width: iconSize,
              height: iconSize
            })
          : null}
      </MuiButtonBase>
    );
  }
}

const styles = (theme: ThemeType) =>
  createStyles({
    root: {
      "& > span > *:not(:last-child)": {
        marginRight: theme.spacing()
      }

      // patching mui button
      // https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/Button/Button.js#L88
      // "&:focus": {
      //   boxShadow: theme.shadows[8]
      // }
    },

    iconButton: {
      minWidth: ["auto", "!important"] as any,

      "& svg": {
        marginRight: [0, "!important"] as any
      }
    },

    leftIcon: {
      marginRight: theme.spacing(1 / 2)
    },
    rightIcon: {}
  });

export default withStyles(styles)(BaseIconButton);
